import { ReactNode, createContext, useState, useEffect } from "react";
import { useHistory } from 'react-router-dom';
import { auth } from '../services/firebase';
import { toast } from 'react-toastify';

export type Admin = {
    id?: string;
    name?: string;
    email?: string;
    password?: string;
}

type AdminContextType = {
    admin: Admin | undefined;
    handleSignIn: (email: string, password: string) => Promise<void>;
}

type AuthContextProviderProps = {
    children: ReactNode;
}

export const AdminContext = createContext({} as AdminContextType);

export function AdminContextProvider(props: AuthContextProviderProps) {
    const [admin, setAdmin] = useState<Admin>();

    const history = useHistory();

    useEffect(() => {

        const unsubscribe = auth.onAuthStateChanged(admin => {
            if (admin) {
                const { email, uid } = admin

                if (!email) {
                    throw new Error('Missing information from Google Account')
                }

                setAdmin({
                    id: uid,
                    email: email,
                })
            }
        })

        return () => {
            unsubscribe();
        }
    }, [])

    async function handleSignIn(email: string, password: string): Promise<void> {

        try {
            await auth.signInWithEmailAndPassword(email, password);

            setAdmin({
                email: email,
            })
            history.push(`/adminpage`, admin);

        } catch (error) {
            toast.error('Não foi possível autenticar seu login, tente novamente em instantes!');
        }
    }

    return (
        <AdminContext.Provider value={{ admin, handleSignIn }}>
            {props.children}
        </AdminContext.Provider>
    );
}